
export const types = {
  EPG_DATA_FETCH: 'EPGVerticalList/EPG_DATA_FETCH',
  EPG_DATA_FETCH_FAILURE: 'EPGVerticalList/EPG_DATA_FETCH_FAILURE',
  EPG_DATA_FETCH_SUCCESS: 'EPGVerticalList/EPG_DATA_FETCH_SUCCESS',
  SELECTED_DAY_CHANGED: 'EPGVerticalList/SELECTED_DAY_CHANGED'
};
